/** File upload trigger for learner UI. Wraps React Aria FileTrigger. */
import {
  FileTrigger as AriaFileTrigger,
  type FileTriggerProps as AriaFileTriggerProps,
} from 'react-aria-components';

export type FileTriggerProps = AriaFileTriggerProps;

export function FileTrigger(props: FileTriggerProps) {
  return <AriaFileTrigger {...props} />;
}
